import {NumberUtil} from "base/utilities";

export function useTable() {
    const tableColumns = [
        {
            id: "name",
            label: "Name",
            width: 8,
        },
        // {
        //     id: "type",
        //     label: "Type",
        //     width: 8,
        // },
        {
            id: "gva_me",
            label: "Current GVA (€ million)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.gva_me),
        },
        {
            id: "gva_per",
            label: "Direct Impact % of national GDP ",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.gva_per),
        },
        {
            id: "di_gva_me",
            label: "Direct Impact (€ million)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.di_gva_me),
        },
        {
            id: "di_gva_per",
            label: "Indirect and induced % of national GDP",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.di_gva_per),
        },
        {
            id: "tii_gva_me",
            label: "Total Impact (€ million)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.tii_gva_me),
        },
        {
            id: "tii_gva_per",
            label: "Total Impact % of national GDP",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatDecimal(element.tii_gva_per),
        },
        {
            id: "emp_n",
            label: "Current Employment (Nº Persons)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.emp_n),
        },
        {
            id: "emp_per",
            label: "Indirect and induced Employment in the country",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.emp_per),
        },
        {
            id: "di_emp_n",
            label: "Direct Impact Employment (Nº Persons)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.di_emp_n),
        },
        {
            id: "di_emp_per",
            label: "Direct Impact Employment (%)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.di_emp_per),
        },
        {
            id: "tii_emp_n",
            label: "Total Employment (Nº Persons)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.tii_emp_n),
        },
        {
            id: "tii_emp_per",
            label: "Total Employment (%)",
            width: 10,
            align: "right",
            formatFunction: element => NumberUtil.formatNumber(element.tii_emp_per),
        },
        // {
        //     id: "top5",
        //     label: "Top 5 non-MSP sectors impacted",
        //     width: 10,
        // },
    ];

    return {tableColumns};
}
